import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents-list-icon" }
const _hoisted_3 = { class: "contents-list-icon-main" }
const _hoisted_4 = { class: "contents-question-finish-text" }
const _hoisted_5 = { class: "contents-question-button" }
const _hoisted_6 = { href: "#" }
const _hoisted_7 = {
  type: "button",
  id: "pagetop-button"
}

import Footer from "@/components/modules/base/Footer.vue";

const componentId = "generalpurpose03-02-c";

export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyFormComplete',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("header", null, [
          _createElementVNode("h1", { class: "header-icon" }, [
            _createElementVNode("a", { href: "#" }, [
              _createElementVNode("img", { src: "/server/necs/images/kanshin_logo.png" })
            ])
          ])
        ], -1)),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("survey_msg_complete")), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contents-list-icon-tri" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("survey_msg_thanks")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, [
              _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.$t("survey_button_link_top")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Footer, { "scroll-target": componentId })
  ], 64))
}
}

})